import { motion } from 'framer-motion';
import { Mic, GraduationCap, ChevronRight, ChevronLeft, BookOpen } from 'lucide-react';
import { toast } from 'sonner';
import { getT } from './i18n';

export default function FormationsListPage({ onBack, onOpenEnglish, onOpenPro, lang = 'fr' }) {
  const t = getT(lang);
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      className="max-w-7xl mx-auto px-4 py-10" data-testid="formations-list-page">
      <button onClick={onBack} className="text-white/60 hover:text-white text-sm mb-6 flex items-center gap-1">
        <ChevronLeft size={16} />{t('back')}
      </button>

      {/* Header */}
      <div className="text-center mb-10">
        <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-4 py-1.5 text-xs text-emerald-300 mb-4">
          <BookOpen size={12} />{t('formations_catalog_badge')}
        </div>
        <h1 className="text-3xl sm:text-5xl font-black tracking-tight">
          <span className="bg-gradient-to-r from-emerald-300 via-yellow-300 to-emerald-200 bg-clip-text text-transparent">{t('formations_title')}</span>
        </h1>
        <p className="text-white/70 mt-3 max-w-2xl mx-auto">{t('formations_intro')}</p>
      </div>

      {/* Card 1 — Languages (bidirectional EN ↔ FR) */}
      <div className="grid sm:grid-cols-2 gap-5 mb-10">
        <motion.button whileHover={{ y: -4 }} onClick={onOpenEnglish} data-testid="formation-card-english"
          className="text-left rounded-3xl p-8 bg-gradient-to-br from-emerald-500 to-emerald-700 relative overflow-hidden group">
          <div className="absolute -right-4 -bottom-4 text-7xl opacity-10 group-hover:opacity-20 transition">🇬🇧</div>
          <Mic size={36} className="text-white/90 mb-4" />
          <div className="text-xs uppercase tracking-wider text-white/70">{t('formation_english_tag')}</div>
          <h3 className="text-2xl font-bold mt-1">{t('formation_english_title')}</h3>
          <p className="text-white/80 mt-2 text-sm">{t('formation_english_desc')}</p>
          <div className="inline-flex items-center gap-1 mt-5 text-sm font-bold bg-white/20 backdrop-blur px-3 py-1.5 rounded-full">
            {t('formation_english_cta')}<ChevronRight size={14} />
          </div>
        </motion.button>

        <motion.button whileHover={{ y: -4 }} data-testid="formation-card-pro"
          onClick={onOpenPro}
          className="text-left rounded-3xl p-8 bg-gradient-to-br from-blue-700 to-purple-800 relative overflow-hidden group">
          <div className="absolute -right-6 -bottom-6 text-9xl opacity-10 group-hover:opacity-20 transition">🎓</div>
          <GraduationCap size={36} className="text-white/90 mb-4" />
          <div className="text-xs uppercase tracking-wider text-white/70">{t('formation_pro_tag')}</div>
          <h3 className="text-2xl font-bold mt-1">{t('formation_pro_title')}</h3>
          <p className="text-white/80 mt-2 text-sm">{t('formation_pro_desc')}</p>
          <div className="inline-flex items-center gap-1 mt-5 text-sm font-bold bg-white/20 backdrop-blur px-3 py-1.5 rounded-full">
            {t('formation_pro_cta')}<ChevronRight size={14} />
          </div>
        </motion.button>
      </div>

      {/* Info banner */}
      <div className="bg-white/5 border border-white/10 rounded-2xl p-5 text-center">
        <div className="text-sm text-white/70">{t('formations_more_banner')}</div>
      </div>
    </motion.div>
  );
}
